var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8602 38.14C28.4802 38.14 28.1002 38 27.8002 37.7C27.2202 37.12 27.2202 36.16 27.8002 35.58L38.8802 24.5L27.8002 13.42C27.2202 12.84 27.2202 11.88 27.8002 11.3C28.3802 10.72 29.3402 10.72 29.9202 11.3L42.0602 23.44C42.6402 24.02 42.6402 24.98 42.0602 25.56L29.9202 37.7C29.6202 38 29.2402 38.14 28.8602 38.14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.66 26H7C6.18 26 5.5 25.32 5.5 24.5C5.5 23.68 6.18 23 7 23H40.66C41.48 23 42.16 23.68 42.16 24.5C42.16 25.32 41.48 26 40.66 26Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.e4b718492e2bf85ab3b6fc438e202b24.svg";
export { ForwardRef as ReactComponent };